import { z } from 'zod';
import { Contact } from './common';
export var HelpContact = Contact;
export var HelpContacts = z.array(HelpContact).prefault([]);
